const translations = {
  "AZ": {
    home: "Home",
    cars: "Cars",
    contact: "Contact Us",
    news: "News",
    bloglist: "Blog List",
    blogdetail: "Blog Details",
    carlist: "Car Listings",
    cardetails: "Listing Details",
    explorecars: "Explore All Cars",
    recently: "Recently Added",
    viewdetails: "View Details",
    newcars: "New Cars",
    usedcars: "Used Cars",
    blogPage: "Blog Page",
    blogDetails: "Blog Details",
    contactPage: "Contact Page",
    contactPhone: "Phone Number",
    contactAddress: "Address",
    contactOpening: "Opening Hours",
    productSearch: "Search by Filter",
    productSearchHere: "Search here",
    price: "Price",
    min: "Min",
    max: "Max",
    marka: "Brand",
    model: "Model",
    year: "Year",
    color: "Color",
    ban: "Body Type",
    engineType: "Fuel Type",
    transmission: "Transmission",
    all: "All",
    new: "New",
    used: "Used",
    sort: "More Filters",
    mileage: "Mileage",
    overview: "Overview",
    seats: "Seats",
    hp: "Hp",
    engineSize: "Engine Size",
    gear: "Gear",
    sort1: "A to Z",
    sort2: "Z to A",
    sort3: "Lowest Price First",
    sort4: "Highest Price First",
    noresult: "No cars found",
    allCars: "All Cars",
    reserved: "All rights reserved.",
    result: "Showing",
    result2: "results",
    row: "Row",
    location: "DSO IFZA - IFZA Properties Dubai Silicon Oasis, Dubai UAE",
    location1: "43 Neftchilar Ave., underground parking of Government House",
    today: "Everyday",
    about: "About Us",
    private: "Privacy Policy",
    terms: "Terms and Conditions",
    name: "Full Name",
    email: "Email",
    phone: "Your Phone Number",
    desc: "Order Note",
    buynow: "ORDER",
    carInfo: "Additional Information",
    nameValid: "Please fill in this field",
    emailValid: "Email cannot be empty",
    phoneValid: "Phone number cannot be empty",
    descValid: "Message field cannot be empty",

    notfound: "PAGE NOT FOUND",
    notfound1: "Oops! Page not found",
    notfound2: "The page you are looking for does not exist.",

    orderTitle: "PLACE ORDER",
    parts: "Buy in Installments",
    payment: "Minimum down payment is 30%",
    credit: "Credit term:",
    month: "month",
    payment2: "Monthly payment:",
    send: "Submit Request",
    condition: "Condition",
    alert: "Your order has been received.",
    productDesc: "The perfect combination of style and affordability! Our prices will pleasantly surprise you. Dive into the world of quality cars at affordable prices.",
    buyNow1: "Buy Now",
    sliderImg: "Li L7 – Harmony of technology and comfort.",
    sliderImg1: "Perfect design, incredible performance, and comfort.",
    odenisEt: "Monthly Payment",

    back: "BACK",
    paymentTitle: "Enter payment details",
    fin: "Identification Number (FIN CODE)",
    customerCode: "Customer Code",
    creditTitle: "Information about credit payment process",
    signIn: "Payment",

    paymentResult: "Payment Details",
    soyadad: "Surname, Name, Patronymic",
    mobilnomre: "Mobile Number",
    umumiborc: "Total Debt",
    odenisCredit: "Contract for payment:",
    odenilecekMebleg: "Amount to be paid:",
    odenisPlaceholder: "Enter payment amount",

    qebz1: "Receipt",
    borcMelumati: "Customer Debt Information",
    sifarisKodu: "Order Code",
    tarix: "Date",
    saa: "Full Name",
    mobil: "Mobile",
    fin: "FIN",
    muqavile: "Contract No.",
    odenildi: "Paid",
    qaliqborc: "Remaining Debt",
    odenisUsulu: "Payment Method: Kapital Bank",
    thankPage: "Thank you! We look forward to seeing you again",
    print: "Print",

    gonder: "Send",
    qebz: "Send receipt via email",
    epoctunvan: "Enter your email address",
    successepoct: "Email sent successfully"
  }
  // "RU":{
  //     home:"Главная",
  //     cars:"Легковые автомобили",
  //     contact:"Подключите нас",
  //     news:"Новости",
  //     bloglist:"Список блогов",
  //     blogdetail:"Подробности блога",
  //     carlist:"Объявления об автомобилях",
  //     cardetails:"Детали объявлений",
  //     explorecars:"Исследуйте все автомобили",
  //     recently:"Недавно добавленный",
  //     viewdetails:"Подробнее",
  //     newcars:"Новые автомобили",
  //     usedcars:"Подержанные автомобили",
  //     blogPage:"Страница блога",
  //     blogDetails:"Подробности блога",
  //     contactPage:"Подключите нас",
  //     contactPhone:"Номер телефона",
  //     contactAddress:"Адрес",
  //     contactOpening:"Часы работы",
  //     productSearch:"Поиск по фильтру",
  //     productSearchHere:"Поищи здесь",
  //     price:"Цена",
  //     min:"Мин",
  //     max:"Макс",
  //     marka:"Бренд",
  //     model:"Модель",
  //     year:"Год",
  //     color:"Цвет",
  //     ban:"Тип кузова",
  //     engineType:"Тип топлива",
  //     transmission:"Коробка передач",
  //     all:"Все",
  //     new:"Новый",
  //     used:"Ездил",
  //     sort:"Больше фильтров",
  //     mileage:"Пробег",
  //     overview:"Обзор автомобиля",
  //     seats:"Сиденья",
  //     hp:"л.с.",
  //     engineSize:"Размер двигателя",
  //     gear:"Механизм",
  //     sort1:"A-З",
  //     sort2:"З-A",
  //     sort3:"От дешевого к дорогому",
  //     sort4:"От дорогого к дешевому",
  //     noresult:"Автомобиль не найден",
  //     allCars:"Все автомобили",
  //     reserved:"Сайт защищен авторским правом.",
  //     result:"от результата",
  //     result2:"между показано",
  //     row:"Ряд",
  //     location:"DSO IFZA – Недвижимость IFZA, Дубай Силикон Оазис, Дубай, ОАЭ",
  //     location1:"проспект Нефтяников, 43, подземная автостоянка Дома Правительства",
  //     today:"Каждый день",
  //     about:"О нас",
  //     private:"Политика безопасности",
  //     terms:"Условия и положения",
  //     name:"Имя,Фамилия,Отчество",
  //     email:"Электронная почта",
  //     phone:"Номер мобильного телефона",
  //     desc:"Примечание к заказу",
  //     buynow:"ЗАКАЗ",
  //     carInfo:"Дополнительная информация",
  //     nameValid:"Пожалуйста, заполните поле",
  //     emailValid:"Электронную почту нельзя оставить пустым",
  //     phoneValid:"Номер телефона не может быть пустым",
  //     descValid:"Поле сообщения нельзя оставить пустым",
  //     about1:"Mycars.az — ведущий сайт объявлений для пользователей ОАЭ. С момента своего запуска Эмилем Искендеровым в 2022 году mycars.az стал платформой номер один, где пользователи могут покупать, продавать или находить что-либо в своем сообществе. Сообщество, в котором недостаточно используемые товары перераспределяются для удовлетворения новых потребностей и снова становятся востребованными, где непродуктовые активы, такие как пространство, навыки и деньги, обмениваются и продаются новыми способами, которые не всегда требуют централизованных институтов или «посредников».",
  //     privateDesc:"Политика конфиденциальности Мы очень серьезно относимся к вашей конфиденциальности и обязуемся защищать конфиденциальность всех посетителей и подписчиков нашего веб-сайта или любого приложения, которое мы предоставляем через магазин приложений («Платформа»), а также соответствующие услуги, доступные через Платформу («Услуги»). Ниже мы излагаем нашу политику конфиденциальности, которая будет регулировать способ обработки любой персональной информации, которую вы предоставите нам. Мы уведомим вас, если способ обработки ваших данных изменится в любое время. Пожалуйста, внимательно ознакомьтесь с нашей политикой конфиденциальности, так как она содержит важную информацию о том, кто мы такие и как мы собираем, храним, используем и распространяем вашу информацию. Получая доступ к Платформе или используя наши Услуги или иным образом выражая свое согласие, вы соглашаетесь, и где это требуется, соглашаетесь с сбором, использованием и передачей ваших данных в соответствии с настоящей политикой. Если вы не принимаете условия настоящей политики, вы не должны использовать Платформу и/или Услуги. Эта политика конфиденциальности дополняет другие уведомления и политики конфиденциальности и не предполагает их замену. Эта политика конфиденциальности: (i) применяется только к Платформе, а не к веб-сайтам или приложениям других компаний или организаций; и (ii) специально адресует наши обязательства в соответствии с местным законодательством. Данные, которые мы собираем о вас  Когда вы посещаете нашу Платформу или создаете логин и пароль для доступа к Услугам, вам может быть предложено предоставить информацию о себе. Это может включать в себя: (i) ваше имя и контактные данные, включая адрес электронной почты и номер телефона; (ii) информацию, позволяющую нам проверить и подтвердить вашу личность; (iii) местоположение; (iv) ваши платежные данные, информацию о транзакциях и историю платежей; и (v) такую другую информацию, которую мы можем время от времени потребовать для предоставления Услуг и соблюдения применимого законодательства. Вы соглашаетесь и, если это требуется, соглашаетесь на сбор информации о вашем использовании Платформы и Услуг, а также информации из сообщений и связи, которые вы отправляете нам. Эта информация необходима для предоставления вам Услуг. Если вы не предоставите такую информацию, это может задержать или предотвратить предоставление Услуг.Эта политика конфиденциальности также будет применяться при доступе к Платформе и/или Услугам с мобильных устройств (таких как мобильные телефоны, планшеты или другие устройства). Если вы не выбрали оставаться анонимным через настройки вашего устройства и/или платформы, эта информация может быть собрана и использована нами автоматически, если вы используете Услуги и получаете доступ к Платформе с мобильного устройства.Звонки между вами и нами, или",
  //     termsDesc:"Добро пожаловать в MyCars!",
  //     termsDesc1:'ПОЖАЛУЙСТА, ОЗНАКОМЬТЕСЬ С ЭТОЙ ВАЖНОЙ ЮРИДИЧЕСКОЙ ИНФОРМАЦИЕЙ, КОТОРАЯ РЕГУЛИРУЕТ ВАШЕ ИСПОЛЬЗОВАНИЕ ВЕБ-САЙТА MyCars.az И УСЛУГ.23 марта 2022 года Используя http://www.mycars.az или мобильное приложение MyCars онлайн-платформы (в дальнейшем «Сайт»), вы подтверждаете, что ознакомились, поняли и принимаете эти условия использования («Условия») как правила, которые регулируют ваш доступ к и использование Сайта и Услуг, и соглашаетесь их соблюдать. Если вы не принимаете или не соглашаетесь с этими Условиями, вы не должны использовать этот Веб-сайт. Кроме того, используя часть Услуги, вы соглашаетесь соблюдать любые применимые размещенные руководства для такой Услуги, которые могут изменяться или обновляться время от времени по нашему собственному усмотрению. Эти Условия заключены между Mycars («мы» «нас» «наши», «Компания», по мере применимости) и вами («вы» или «Пользователь»). Компания является частью Группы EMPG, которая управляет различными веб-сайтами и Сайтом. Группа EMPG также предлагает услуги, отличные от Услуги, такие как проверка автомобилей, оценка автомобилей и фотосъемка. Услуги на материке ОАЭ, такие как проверка автомобилей, оценка и услуги по брокерству автомобилей, также выполняются MyGroup LLC.  Если вы являетесь компанией, размещающей рекламу на нашем сайте, вам потребуется заключить дополнительные условия и положения, изложенные в нашем Рекламном соглашении, однако обратите внимание, что эти Условия также будут применяться и должны быть прочитаны в сочетании с любым другим соглашением, которое вы заключаете с Компанией. ОПРЕДЕЛЕНИЯ 1.1 Следующие заглавные термины имеют следующие значения, если контекст не требует иного: «Рекламное соглашение» - соглашение о предоставлении рекламных услуг или продуктов, заключенное между Компанией и Клиентом. «Пакет рекламных услуг» - пакет рекламных продуктов или услуг, которые Компания соглашается предоставить Клиенту, как это указано в соответствующей форме заказа, предоставленной Компанией и подписанной Клиентом для заказа пакета рекламных услуг в соответствии с этими Условиями и условиями Рекламного соглашения. «Аффилированные лица» - любая компания, контролируемая или принадлежащая Myshops, любая компания, обычно контролируемая или принадлежащая Myshops, и любая сущность Группы EMPG, совместно предлагающая Услугу."Myshops" - Myshops Web MyGroup FZ-LLC, владелец www.mygrop.ae. "Клиент" - клиентская сущность, являющаяся стороной Рекламного соглашения."Клиент" - любой клиент Клиента. "Мойкарты" - MyGroup FZ-LLC, владелец www.mycars.az. «Дата вступления в силу» - дата, указанная в верхней части этих Условий."Моя группа" - Группа компаний Emerging Markets Property Group (EMPG), включая, в частности, MyCars, Mygroup и любые их аффилированные лица."Интеллектуальные права" - все интеллектуальные права, включая патенты, товарные знаки, права на благосклонность, права на базы данных и права на данные, права на дизайн, авторские права и права на топографию (независимо от того, зарегистрированы ли эти права, включая заявки и право на подачу заявки на регистрацию любых таких прав) и все изобретения, права на ноу-хау, коммерческую тайну и конфиденциальную информацию, списки клиентов и поставщиков и другие собственные знания и информацию и все права по лицензиям и согласиям в отношении любых таких прав и все права и формы защиты аналогичного характера или имеющие аналогичное или сходное действие к любому из этих, которые могут существовать в любом месте в мире в течение всего срока их действия, включая все обновления и продления."Материал" - материал и содержание, опубликованные на Веб-сайте или иным образом предоставленные Компанией в связи с Услугой. "Политика конфиденциальности" - политика конфиденциальности Компании на момент времени. "Продукт" - онлайн-платформа для объявлений, предоставленная на Веб-сайте, и Пакет рекламных услуг. "Агенты размещения" - третьи агенты, службы или посредники, предлагающие размещение материала на Сервисе от имени других. "Регистрационные данные" - данные, которые пользователь должен предоставить при регистрации на Веб-сайте из времени во время (например, имя, номера телефонов, адрес электронной почты, возраст и/или адрес)."Услуга" - предоставление Веб-сайта и Продукта.',
  //     notfound:"СТРАНИЦА НЕ НАЙДЕНА",
  //     notfound1:"Упс! Страница не найдена",
  //     notfound2:"Страница, которую вы ищете, не существует.",
  //     orderTitle:"РАЗМЕСТИТЬ ЗАКАЗ",
  //     parts:"Купить в рассрочку",
  //     payment:"Первоначальный взнос составляет минимум 30%.",
  //     credit:"Срок кредита :",
  //     month:"mесяц",
  //     payment2:"Ежемесячно оплата :",
  //     send:"Отправить заявление",
  //     condition:"Ситуация",
  //     alert:"Ваш заказ зарегистрирован.",
  //     productDesc:"Совершенное сочетание стиля и удобства! Наши цены вас приятно удивят. Погрузитесь в мир качественных автомобилей по выгодным ценам.",
  //     buyNow1:"Купить сейчас",
  //     sliderImg:"Li L7 – Гармония технологий и комфорта.",
  //     sliderImg1:"Идеальный дизайн, невероятная производительность и комфорт.",
  //     odenisEt:"Ежемесячный платеж",



  //     back:"НАЗАД",
  //     paymentTitle:"Введите данные для оплаты",
  //     fin:"Идентификационный номер (ФИН КОД)",
  //     customerCode:"Код клиента",
  //     creditTitle:"Информация о процессе кредитной оплаты",
  //     signIn:"Оплатить",
  //     finDesc:` *При неправильном вводе идентификационного номера <br /> 
  //     <font color="red"> операция оплаты может быть неуспешной.</font>`,
  //     myCarsCredit:"Оплата кредита MyCars",
  //     myCarsCreditDesc: `
  //     <li style="list-style: outside; margin-top: 10px;">
  //       С помощью этой формы вы можете легко оплатить кредит
  //       за автомобиль, приобретённый на сайте MyCars.az или в
  //       наших салонах.
  //     </li>

  //     <li style="list-style: outside; margin-top: 10px;">
  //       Пожалуйста, правильно введите ФИН и Код клиента – эти
  //       данные используются для идентификации вашей оплаты и
  //       корректного закрытия вашего счёта.
  //     </li>

  //     <li style="list-style: outside; margin-top: 10px;">
  //       Введённые вами данные используются только для процесса
  //       оплаты и не передаются третьим лицам.
  //     </li>

  //     <li style="list-style: outside; margin-top: 10px;">
  //       После заполнения формы нажмите кнопку ‘Оплатить кредит’,
  //       чтобы завершить платёж безопасно и быстро.
  //     </li>

  //     <li style="list-style: outside; margin-top: 10px;">
  //       Если у вас возникнут вопросы, наша служба поддержки
  //       всегда готова вам помочь.
  //     </li>
  //   `,
  //   paymentResult:"Информация об оплате",
  //   soyadad:"Фамилия, Имя, Отчество",
  //   mobilnomre:"Мобильный номер",
  //   umumiborc:"Общая задолженность",
  //   odenisCredit:"Контракт для оплаты :",
  //   odenilecekMebleg:"Сумма к оплате :",
  //   odenisPlaceholder:"Укажите сумму к оплате",
  //   odenisEt:"Ежемесячный платеж",


  //   qebz1:"Квитанция",
  //   borcMelumati:"Информация о задолженности клиента",
  //   sifarisKodu:"Код заказа",
  //   tarix:"Дата",
  //   saa:"Ф.И.О.",
  //   mobil:"Мобильный",
  //   fin:"ФИН",
  //   muqavile:"Договор №",
  //   odenildi:"Оплачено",
  //   qaliqborc:"Остаток задолженности",
  //   odenisUsulu:"Способ оплаты: Kapital Bank",
  //   thankPage:"Спасибо! Ждём вас снова",
  //   print:"Распечатать",

  //   gonder: "Отправить",
  //   qebz: "Отправить квитанцию на e-mail",
  //   epoctunvan: "Укажите свой адрес электронной почты",
  //   successepoct: "E-mail успешно отправлен"



  // }
}


export default translations;